import startYourClub from '../../assets/three-steps/start-your-club.webp'
import meetingDetailsView from '../../assets/three-steps/meeting-details-view.webp'
import step3 from '../../assets/three-steps/step-3.webp'

const steps = [
  {
    step: '1',
    name: 'Set up your club in minutes',
    time: '~5 minutes',
    description:
      'Name your club, import your roster from CSV or invite members by email, and set your meeting day once. Browser-based - nothing to install',
    image: startYourClub,
  },
  {
    step: '2',
    name: 'Roles fill themselves',
    time: 'ongoing',
    description:
      'Members claim and swap roles, auto-assign covers the gaps, and a digest keeps everyone posted automatically',
    image: meetingDetailsView,
  },
  {
    step: '3',
    name: 'Share one live link',
    time: 'instant',
    description:
      'Members, guests - everyone sees the current agenda from any phone. Nothing to regenerate, nothing to re-send',
    image: step3,
  },
]

export default function LandingHowItWorks() {
  return (
    <div id="how-it-works" className="bg-gray-50 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-indigo-600">
            How it works
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            From empty agenda to running meeting in three step
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Before your next meeting - not after a migration project
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-12 lg:max-w-none lg:grid-cols-3">
            {steps.map((step) => (
              <div key={step.name} className="flex flex-col">
                <div className="mb-6 flex aspect-[4/3] items-center justify-center overflow-hidden rounded-2xl border border-gray-300 bg-gray-100">
                  <img
                    src={step.image}
                    alt={step.name}
                    className="h-full w-full object-cover"
                  />
                </div>
                <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900">
                  <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-indigo-600 text-lg font-bold text-white">
                    {step.step}
                  </div>
                  {step.name}
                  <span className="ml-auto rounded-full bg-indigo-50 px-2.5 py-0.5 text-xs font-medium text-indigo-700">
                    {step.time}
                  </span>
                </dt>
                <dd className="mt-3 text-base leading-7 text-gray-600">
                  {step.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
